const transformOffers = (offers, isOffline) => {
  return isOffline ? offers : offers.map(offer => ({ value: offer }))
}

export default {
  fillOfflineOffers({ commit }, offers) {
    commit("setOffers", transformOffers(offers, true))
  },
  fillOffers({ commit }, offers) {
    commit("setOffers", transformOffers(offers, false))
  }
}
